import { ArrowUpRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Overline } from "./Reveal";
import { FAQS } from "@/data/content";
import { useBooking } from "@/booking";

export const FAQ = () => {
  const openBooking = useBooking();

  return (
    <section id="faq" data-testid="faq-section" className="py-24 sm:py-32">
      <div className="mx-auto grid max-w-6xl gap-14 px-5 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <Overline>FAQ</Overline>
              <h2 className="mt-4 font-heading text-2xl font-extrabold tracking-tight text-ink sm:text-3xl lg:text-4xl">
                Frequently Asked Questions
              </h2>
              <p className="mt-4 text-base leading-relaxed text-ink-muted">
                Everything you need to know before taking your first step.
              </p>
              <button
                data-testid="faq-book-call-btn"
                onClick={openBooking}
                className="group mt-8 inline-flex items-center gap-2 rounded-full bg-peach-dark px-6 py-3.5 font-heading text-[13px] font-bold text-cream shadow-[0_14px_35px_-14px_rgba(226,121,111,0.8)] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-peach-deeper"
              >
                Book My Strategy Call — ₹199
                <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </button>
            </Reveal>
          </div>
        </div>
        <div className="lg:col-span-8">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem key={f.q} value={`faq-${i}`} className="border-peach/20" data-testid={`faq-item-${i}`}>
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="py-5 text-left font-heading text-base font-bold text-ink transition-colors hover:text-peach-dark hover:no-underline sm:text-lg"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm leading-relaxed text-ink-muted sm:text-base">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
